import { memo, useEffect } from 'react';

import endpoints from '../../../../../../../../api/endpoints';
import { WithLoader } from '../../../../../../../common/loader';
import { useFetch } from '../../../../../../../../api/useFetch';

import { useSettingsUpdate } from './hooks';
import { EditNotificationSettings } from './steps';
import { LowBalanceNotificationResponseData } from './interfaces';

interface Props {
  handleClose: () => void;
  handleUnlock: () => void;
}

const LowBalanceNotification = ({ handleClose, handleUnlock }: Props) => {
  const { lowBalanceNotificationError, lowBalanceNotificationLoading, handleSettingsUpdate } = useSettingsUpdate();

  const {
    data: lowBalanceData = {} as LowBalanceNotificationResponseData,
    refresh: getSettingsRefresh,
    loading: getSettingsLoading
  } = useFetch<LowBalanceNotificationResponseData>({
    pathname: endpoints.clientLowBalance
  });

  useEffect(() => {
    handleUnlock();
  });

  return (
    <WithLoader height="200px" loading={getSettingsLoading}>
      <EditNotificationSettings
        initialValues={lowBalanceData}
        handleClose={handleClose}
        onSubmit={data => {
          handleSettingsUpdate(data, getSettingsRefresh);
        }}
        loading={lowBalanceNotificationLoading}
        error={lowBalanceNotificationError}
      />
    </WithLoader>
  );
};

export default memo(LowBalanceNotification);
